import React, { useContext, useEffect } from "react";
import { string, array } from "prop-types";
import { INPUT_TYPES } from "utils/CommonConstants";
import TextInput from "sub_components/Common/BloxTextInput";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import RadioButton from "sub_components/Common/Radio";
import { WIZARD_TITLE_PREFIXES } from "utils/TicketConstants";
import {
  getTitlePlaceholder,
  getGuestAccessTickets,
  getRemoteHandsTickets,
} from "utils/SupportUtils";
import styled from "styled-components";
import { ServiceRequestContext } from "context/ServiceRequestContext";

const OPTIONS = [
  { name: "Gate Access", value: 1 },
  { name: "Gate and Hut Access", value: 2 },
];

const DescriptionScreenStyle = styled.div`
  height: 158px;
  .blox-text-input {
    width: 100%;
    margin-bottom: 8px;
  }
  .ScrollbarsCustom-Track {
    right: -20px !important;
    top: 0px !important;
  }
  .ScrollbarsCustom-ThumbY {
    background-color: ${(props) => props.theme.support} !important;
    width: 6px !important;
  }
  .ScrollbarsCustom-TrackY:before {
    border-left: none;
  }
  .ScrollbarsCustom-TrackY {
    background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
    box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
      1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
    width: 6px !important;
  }
  .blox-text-input.text-area-field {
    margin-bottom: 0px;
  }
  .input-label {
    margin-bottom: 5px;
  }

  .input-text {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid ${(props) => props.theme.Purple};
    background-color: transparent;
    min-height: 25px;
    cursor: pointer;
    margin-bottom: 8px;
  }
  .radio-wrapper {
    margin-bottom: 8px;
  }

  .blox-text-input.active {
    textarea {
      max-height: 50px;
    }
  }
  .radio-wrapper {
    width: 25vw;
  }
  .options {
    display: flex;
  }
  .info-text {
    text-align: center;
    margin-bottom: 10px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 220px;
    .blox-text-input {
      margin-bottom: 8px;
    }
    .input-text {
      min-height: 25px;

      margin-bottom: 20px;
    }
    .radio-wrapper {
      width: 32vw;
      margin-bottom: 20px;
    }
    .radio-selection {
      width: 200px;
    }

    .ScrollbarsCustom-Track {
      right: -30px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 8px !important;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 395px;
    .blox-text-input {
      margin-bottom: 50px;
    }
    .blox-text-input.active {
      textarea {
        max-height: 75px;
      }
    }
    .radio-selection {
      width: 200px;
    }
    .radio-wrapper {
      margin-top: 8px;
      margin-bottom: 50px;
    }
    .ScrollbarsCustom-Track {
      right: -45px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 20px !important;
    }
  }
`;

function checkRemoteHands(remoteHandsTickets, value) {
  let matchingTitle = "";
  remoteHandsTickets.forEach((ticket) => {
    let title = null;
    const matches = ticket.name.match(/Remote Hands Request - (.*)/);

    if (matches && matches[1]) {
      title = matches[1];
    }
    if (title === value) {
      matchingTitle = title;
    }
  });
  return matchingTitle;
}

function checkGuestAccess(guestAccessTickets, value) {
  let matchingTitle = "";
  guestAccessTickets.forEach((ticket) => {
    let title = null;
    const matches = ticket.name.match(/Guest Access Request - (.*)/);
    if (matches && matches[1]) {
      title = matches[1];
    }
    if (title === value) {
      matchingTitle = title;
    }
  });
  return matchingTitle;
}

function checkUnique(value, tickets, type) {
  let matchingTitle = null;
  const guestAccessTickets = tickets && getGuestAccessTickets(tickets);
  if (guestAccessTickets && type !== "REMOTE_HANDS") {
    matchingTitle = checkGuestAccess(guestAccessTickets, value);
  }
  const remoteHandsTickets = tickets && getRemoteHandsTickets(tickets);

  if (remoteHandsTickets && type === "REMOTE_HANDS") {
    matchingTitle = checkRemoteHands(remoteHandsTickets, value);
  }

  return matchingTitle;
}

export const DescriptionScreen = ({ tickets, type }) => {
  const { inputs, change } = useContext(ServiceRequestContext);

  const title =
    type === "REMOTE_HANDS"
      ? WIZARD_TITLE_PREFIXES.REMOTEHANDS
      : WIZARD_TITLE_PREFIXES.GUESTACCESS;
  const defaultTitle = getTitlePlaceholder(title, tickets);

  useEffect(() => {
    change({
      target: {
        name: "title",
        value: inputs?.type === "ila" ? "ILA Access Request" : defaultTitle,
      },
    });
  }, []);

  function handleClearanceChange(value) {
    change({
      target: {
        name: "clearance",
        value,
      },
    });
  }
  console.log("inputs " + JSON.stringify(inputs));
  return (
    <DescriptionScreenStyle className="service-request-description">
      <ScrollView>
        <TextInput
          placeholder=""
          type={INPUT_TYPES.INPUT}
          label="Give your request a title."
          name="title"
          value={inputs.title}
          unique={(value) => checkUnique(value, tickets, type)}
          onChange={change}
          active={true}
          setPlaceholderAsValue
          hideCheckmark
          cypressId="service-request-title"
        />
        {inputs?.type === "ila" && (
          <div className="radio-wrapper">
            <div className="input-label">
              What clearance level do you need for this visit ?
            </div>
            <RadioButton
              callback={handleClearanceChange}
              name="clearanceAccess"
              value={Number(inputs?.clearance)}
              hidden={false}
              toggle={true}
              options={OPTIONS}
              cypressId="clearance"
              id="clearance"
            />
          </div>
        )}
        <TextInput
          placeholder=""
          type={INPUT_TYPES.TEXTAREA}
          label={
            inputs?.type === "ila"
              ? "What is the reason for your visit ?"
              : "What do you need help with?"
          }
          name="description"
          value={inputs.description}
          onChange={change}
          characterMinLength={10}
          showCharacterCount={true}
          active={true}
          hideCheckmark
          cypressId="service-request-description"
          id="service-request-description"
        />
        {inputs?.type === "remote-hands" && (
          <div className="body10">
            Remote Hands is provided on a per request basis. Billed at $180/hr.
            during normal business hours ($240/hr. after normal business hours)
          </div>
        )}
      </ScrollView>
    </DescriptionScreenStyle>
  );
};

DescriptionScreen.propTypes = {
  tickets: array.isRequired,
  type: string,
};

DescriptionScreen.defaultProps = {
  type: "",
};
